import { isStr } from '@utils';
import React, { FC } from 'react';

interface Props {
  title?: string;
  description?: string;
  image?: string;
  keywords?: string | string[];
  url?: string;
  themeColor?: string;
  type?: 'website' | 'article';
  itemProp?: string;
  canonical?: string;
}

const siteName = 'CircleOf';

export const SeoHeader: FC<Props> = ({
  canonical,
  itemProp,
  title,
  description,
  image,
  keywords,
  url,
  themeColor = '#000000',
  type = 'website',
}) => {
  const titleStr = title ? `${title} | ${siteName}` : siteName;
  const keywordsStr = !keywords ? undefined : isStr(keywords) ? keywords : keywords.join(', ');
  return (
    <>
      <title>{titleStr}</title>
      <meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1" />
      {!!description && <meta name="description" content={description} />}
      {!!keywordsStr && <meta name="keywords" content={keywordsStr} />}
      <meta name="theme-color" content={themeColor} />
      {/* Open Graph */}
      <meta property="og:title" content={titleStr} />
      <meta property="og:type" content={type} />
      {!!image && <meta property="og:image" content={image} />}
      {!!url && <meta property="og:url" content={url} />}
      {!!description && <meta property="og:description" content={description} />}
      <meta property="og:site_name" content={siteName} />
      <meta itemProp="description" content={itemProp || description} />
      {!!canonical && <link rel="canonical" href={canonical} />}
      <meta name="facebook-domain-verification" content="ygn3pdekii11rk0goplcx73etpbuxk" />
      <meta name="google-site-verification" content="Jz3ofNC7PkjOnCHAtkFvMUehwqi0rnweeQIqzs2EOfc" />
      <meta name="fo-verify" content="fd5ac87d-e0d3-4c2b-ada3-28da84172428" />
      <meta id="affilimate-token" name="am-api-token" content="RlR7iEdsP" />
    </>
  );
};

export type SeoHeaderProps = Props;
export default SeoHeader;
